import { ButtonHTMLAttributes } from "react";
import "./style.scss";

export enum ButtonType {
  default,
  basic,
  garage,
  new,
  newColored,
  filtre,
  filtreColored,
}

interface ButtonProps extends ButtonHTMLAttributes<any> {
  title?: string;
  type?: "submit" | "reset" | "button";
  style?: React.CSSProperties;
  buttonType?: ButtonType;
  icon?: any;
  iconPosition?: "left" | "right";
  customClassName?: string;
}

const Button = ({
  title,
  customClassName = " ",
  type,
  style,
  iconPosition = "left",
  buttonType,
  icon,
  ...rest
}: ButtonProps) => {
  const buttonCustomClass = () => {
    switch (buttonType) {
      case ButtonType.basic:
        return "bold-text button button-basic";
      case ButtonType.new:
        return " button-new";
      case ButtonType.filtre:
        return " button-filtre";

      case ButtonType.filtreColored:
        return " button-filtreColored";
      case ButtonType.newColored:
        return " button-newColored";
      case ButtonType.garage:
        return "bold-text button button-garage";
      case ButtonType.default:
      default:
        return "bold-text button button-default";
    }
  };

  return (
    <button
      className={buttonCustomClass() + " " + customClassName}
      type={type}
      style={{
        ...(style || {}),
      }}
      {...rest}
    >
      {iconPosition === "left" ? (
        <>
          {icon && icon} {title && <>{title}</>}
        </>
      ) : (
        <>
          {title && <>{title}</>} {icon && icon}
        </>
      )}
    </button>
  );
};

export default Button;
